

let _ = require('../_.js');
let $ = jQuery;

let _data_subscription = null;
let _round = null;

_.AuctionUI_BidHistory = class AuctionUI_BidHistory {

    static init() {

    }

    static async show(round_id) {
        // Close existing modal if any
        await _.Modal.hide();

        // Todo: drop data subscriptions
        _round = await App_Models_AuctionRound.get(round_id);

        if (!_round) {
            _.shouldnt_happen();
            return;
        }

        let $modal = $("#ac-modal-bidhistory");

        $modal.find(".ac-modal-bidhistory-table tbody").empty();

        this.on_data_update();

        if (_data_subscription) {
            _data_subscription.unsubscribe();
            _data_subscription = null;
        }

        $modal.find(".there-are-bids").hide();
        $modal.find(".bids-are-loading").show();
        $modal.find(".there-are-no-bids").hide();

        // Redrawing bids only happens if modal is visible.  So, we need to show the modal before we set up the subscription again.
        $modal.modal_show();

        _data_subscription = await _round.subscribe(true, function () {
            _.AuctionUI_BidHistory.on_data_update();
        });


    }

    static async on_data_update() {

        await _.mutex("bid_history_on_data_update", async function () {

            let $modal = $("#ac-modal-bidhistory");

            if (!$modal.is(":visible")) {
                return;
            }

            let priv_round = await _round.private();
            let priv_bids = await priv_round.bids.fetch_private();

            // ------ Left side data ------
            // let featuredPhoto = await _.lib_items_get_featured_photo(_item);
            // let brief_description = await _.lib_items_get_breif_description(_item);
            let current_bid = priv_round.current_bid ? (await priv_round.current_bid.fetch_private()) : null;
            let best_bid_by_user = await _.Lib_Auction_Bids.best_bid_by_user(priv_round);

            $modal.find(".modal-title").text("Bid History")

            if (_.AuctionUI.auction_is_standard_or_enterprise()) {
                let item = await _.AuctionUI.get_current_item();
                if (item) {
                    $modal.find(".modal-title").text("Bid History - " + item.title);
                } else {
                    _.shouldnt_happen();
                }
            } else if (_.AuctionUI.auction_is_choice()) {
                $modal.find(".modal-title").text("Bid History - Round " + priv_round.round_number);
            }

            // let $photoElement = $modal.find('.item-photo');
            // let $breifDescriptionElement = $modal.find(".ac-modal-bidhistory-item-short-description");
            // let $statusElement = $modal.find(".ac-modal-bidhistory-item-status");
            let $highBidderElement = $modal.find(".ac-modal-bidhistory-item-high-bidder");
            let $yourHighestBidElement = $modal.find(".ac-modal-bidhistory-item-your-highest-bid");
            let $numBidsElement = $modal.find(".ac-modal-bidhistory-item-num-bids");

            // $modal.find(".modal-title").text("Bid History - " + _item.title);
            // Will set to placeholder if no featured photo could be found.
            // $photoElement.divimg(featuredPhoto);
            // $breifDescriptionElement.text(brief_description);

            $highBidderElement.empty().text(current_bid ? _.currency(current_bid.amount) : _.currency(priv_round.starting_bid));

            $yourHighestBidElement.empty().text(best_bid_by_user ? _.currency(best_bid_by_user.amount) : "----");

            $numBidsElement.text(priv_bids.length);

            // ---- Right side bids table ------

            let $bidTableContainer = $modal.find(".ac-modal-bidhistory-table tbody");

            let bidPromises = [];
            let found_ids = [];

            // ----- Starting bid, if any ------
            let starting_bid = false;

            // TODO: Should have enforcement to only show starting bid if it is lower than the lowest accepted bid.
            if (priv_round.starting_bid && (priv_round.status_can_bid || priv_bids.length > 0)) {
                starting_bid = true;

                // -- Create / get bid row --
                let $component = $bidTableContainer.component(-1, "default", {
                    direction: 'desc'
                });

                found_ids.push(-1);

                $component.removeClass("bid-row-high");
                $component.find(".ac-modal-bidhistory-table-row-bid-id").text("");
                $component.find(".ac-modal-bidhistory-table-row-amount").text(_.currency(priv_round.starting_bid));
                $component.find(".ac-modal-bidhistory-table-row-bidder").empty();
                $component.find(".ac-modal-bidhistory-table-row-notes").empty().text("Starting Ask");
                $component.find(".ac-modal-bidhistory-table-row-time").text(priv_round.started_at ? new _.TimeManager().new(priv_round.started_at_localized).human() : "");
            }

            if (priv_bids.length == 0 && !starting_bid) {

                $modal.find(".there-are-no-bids").show();
                $modal.find(".bids-are-loading").hide();
                $modal.find(".there-are-bids").hide();

            } else {

                $modal.find(".there-are-bids").show();
                $modal.find(".bids-are-loading").hide();
                $modal.find(".there-are-no-bids").hide();

                let my_registrant_id = null;
                let my_registration = _.ac_state.registration;

                if (my_registration) {
                    let my_registrant = await my_registration.registrant.fetch();
                    if (my_registrant) {
                        my_registrant_id = my_registrant.id;
                    }
                }

                for (let priv_bid of priv_bids) {

                    // Run these in parallel
                    bidPromises.push((async function () {

                        let registrant = await priv_bid.registrant.fetch_public();

                        // Data integrity issue check hack
                        if (!registrant) return;

                        // Only render these bids.
                        if (priv_bid.registrant_id == registrant.id) {
                            if (!priv_bid.status_show_frontend_all && !priv_bid.status_show_frontend_registrant) {
                                return;
                            }
                        } else {
                            if (!priv_bid.status_show_frontend_all) {
                                return;
                            }
                        }

                        if (priv_bid.status == App_Models_Bid.STATUS_DELETED) {
                            // we shouldn't be getting deleted bids from the backend, but if we screw that up, this will filter them out
                            return;
                        }

                        found_ids.push(priv_bid.id);

                        // -- Create / get bid row --
                        let $component = $bidTableContainer.component(priv_bid.id, "default", {
                            direction: 'desc'
                        });

                        if (priv_bid.status == App_Models_Bid.STATUS_ACCEPTED || priv_bid.status == App_Models_Bid.STATUS_SOLD) {
                            $component.addClass('bid-row-high');
                        } else {
                            $component.removeClass("bid-row-high");
                        }

                        // -- Set bid row content--
                        $component.find(".ac-modal-bidhistory-table-row-bid-id").text(priv_bid.id);

                        if (priv_bid.original_amount && priv_bid.original_amount != priv_bid.amount) {
                            // Price was edited
                            $component.find(".ac-modal-bidhistory-table-row-amount").html('$' + priv_bid.amount.toLocaleString() + ' <i class="fa-solid fa-pencil" style="font-size:11px"></i>');
                        } else {
                            // Not edited
                            $component.find(".ac-modal-bidhistory-table-row-amount").text("$" + priv_bid.amount.toLocaleString());
                        }

                        $component.find(".ac-modal-bidhistory-table-row-bidder").empty().text((priv_bid.paddle_number ? "[" + priv_bid.paddle_number + "] " : "") + ((registrant.is_floor && !_.ac_state.auction.is_import) ? "Floor" : ""));

                        $component.find(".ac-modal-bidhistory-table-row-time").text(new _.TimeManager().new(priv_bid.created_at_localized).human());  // Todo proper date format

                        let $notes_element = $component.find(".ac-modal-bidhistory-table-row-notes");

                        let notes_parts = [];

                        if (priv_bid.auto_bid_parent_id) {
                            notes_parts.push("Auto Bid");
                        }

                        if (priv_round.status == App_Models_AuctionRound.STATUS_SOLD &&
                            priv_bid.status == App_Models_Bid.STATUS_ACCEPTED) {
                            notes_parts.push("WINNING BID")
                            $notes_element.text("WINNING BID");
                        } else if (priv_bid.status_show_frontend_notes) {
                            notes_parts.push(priv_bid.status_show_frontend_notes);
                        } else if (priv_bid.reason) {
                            notes_parts.push(priv_bid.reason);
                        }

                        if (priv_bid.status == App_Models_Bid.STATUS_REJECTED ||
                            priv_bid.status == App_Models_Bid.STATUS_MAX_BID_CANCELED ||
                            priv_bid.status == App_Models_Bid.STATUS_OUTBID_TIE) {
                            $component.addClass('ac-modal-bidhistory-rejected');
                        } else {
                            $component.removeClass('ac-modal-bidhistory-rejected');
                        }

                        if (_.ac_state.registration && priv_bid.registrant_id == my_registrant_id) {
                            $component.find('td').addClass('bid-is-my-bid'); // #dbff00
                        } else {
                            $component.find('td').removeClass('bid-is-my-bid');
                        }

                        let notes = notes_parts.join(" - ");
                        if (notes == "None Given") {
                            notes = '';
                        }
                        $notes_element.empty().text(notes);

                    })());
                };

                await Promise.all(bidPromises);

                // Remove no longer active data
                $bidTableContainer.remove_unlisted_components(found_ids);
            }
        });

    }

}
